import React, { useState, useEffect, useRef } from 'react';
import { deleteWithToken, getLocalStorage, getWithToken, patchWithToken, postWithToken } from '../API/Api';
import { toast } from 'react-toastify';
import Linkify from 'react-linkify';
import Loader from '../components/Loader';
import 'react-calendar/dist/Calendar.css';
import 'react-circular-progressbar/dist/styles.css';
import moment from 'moment';
import CALENDAR_ICON from '../assets/icons/ComniqaiIcon-V3.0/calendar-icon.svg';
import SEARCH_ICON from '../assets/icons/ComniqaiIcon-V3.0/search-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaPlus, FaRegClock } from 'react-icons/fa';
import { MdOutlineDeleteForever, MdOutlineMail, MdOutlineModeEditOutline } from 'react-icons/md';
import CustomModal from '../components/CustomModal';
import { FiCalendar, FiEdit3, FiPhone } from 'react-icons/fi';
import { IoIosArrowDown } from 'react-icons/io';
import { formatText, formatTimestamp } from '../API/Constant';
import { ThumbsDown, ThumbsUp } from 'lucide-react';

const getBackgroundColor = (status) => {
  switch (status) {
    // case 'New':
    //   return '#dbeafe';
    // case 'Qualified':
    //   return '#dcfce7';
    // case 'Archived':
    //   return '#f3e8ff';
    default:
      return 'linear-gradient(to right, #3b82f6, #06b6d4)';
  }
};

const getTextColor = (bgColor) => {
  // Auto choose black or white text for readability
  if (!bgColor) return '#ffffff';
  const hex = bgColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 150 ? '#000000' : '#ffffff';
};

const tabs = ['Details', 'Chat', 'Notes', 'Activities'];

const MyLeads = () => {
  const [leadData, setLeadData] = useState([]);
  const [leadCount, setLeadCount] = useState([]);
  const [leadStatus, setLeadSatus] = useState([]);
  const [apiTokenData, setApiTokenData] = useState('');
  const [getLeadData, setGetLeadData] = useState([]);
  const [leadId, setLeadId] = useState('');
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [filterStatus, setFlterStatus] = useState(null);
  const dateRef = useRef(null);
  const [startDate, setStartDate] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [editLabel, setEditLabel] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [isEditingQuestion, setIsEditingQuestion] = useState(false);
  const [activeTab, setActiveTab] = useState('details');
  const [activeStatus, setActiveStatus] = useState('All');
  const [isEditing, setIsEditing] = useState(false);
  const [editedLead, setEditedLead] = useState({ ...selectedLead });
  const [tooltipData, setTooltipData] = useState({ visible: false, content: '', x: 0, y: 0 });
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const statusTabs = [
    { label: 'All', count: leadCount?.total_leads || 0 },
    { label: 'New', count: leadCount?.new || 0 },
    { label: 'Qualified', count: leadCount?.qualified || 0 },
    { label: 'Archived', count: leadCount?.archived || 0 },
  ];

  const handleMouseEnter = (e, summary) => {
    const { clientX: x, clientY: y } = e;
    setTooltipData({ visible: true, content: summary, x, y });
  };

  const handleMouseLeave = () => {
    setTooltipData({ visible: false, content: '', x: 0, y: 0 });
  };

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
      getstatus(JSON.parse(token));
    }
  }, []);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token && activeStatus) {
      getLeadDetails(JSON.parse(token), activeStatus);
    }
  }, [activeStatus]);

  useEffect(() => {
    const filtered = leadData?.filter((obj) => {
      const name = obj?.name || '';
      const email = obj?.email || '';
      const phone = obj?.phone_number || '';

      return name.toLowerCase().includes(search.toLowerCase()) || email.toLowerCase().includes(search.toLowerCase()) || phone.toLowerCase().includes(search.toLowerCase());
    });

    setFilteredData(filtered);
  }, [search, leadData]);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      handleDateChange(JSON.parse(token));
    }
  }, [filterStatus, startDate]);

  const getLeadDetails = async (token, statusName) => {
    try {
      setLoader(true);

      const response = await getWithToken(`leads-filter-by-status/?status_name=${encodeURIComponent(statusName)}`, token);

      if (response?.status === 200) {
        setLeadData(response?.data);
        setLeadCount(response?.counts);
      } else {
        toast.error('Failed to fetch lead details');
      }
    } catch (error) {
      toast.error('Something went wrong');
    } finally {
      setLoader(false);
    }
  };

  const handleLeadsDetails = (obj) => {
    setLeadId(obj?.id);
    const payload = {
      recipient_id: obj?.recipient_id,
    };
    postWithToken('Lead_ListAPI', apiTokenData, payload)
      .then((response) => {
        if (response.status === 200) {
          setGetLeadData(response?.data);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
        toast.error('Something went wrong');
      });
  };

  const handleToggleChatHistory = (obj) => {
    setLeadId((prevLeadId) => (obj.id === prevLeadId ? null : obj.id));
    if (obj?.id !== leadId) {
      handleLeadsDetails(obj);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleDateChange = (token) => {
    const payload = {
      date: startDate != null ? moment(startDate).format('YYYY-MM-DD') : null,
      status: filterStatus,
    };
    postWithToken('lead_SortingAPI', token, payload)
      .then((response) => {
        if (response.status === 200) {
          setLeadData(response?.data);
          setGetLeadData([]);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };

  const handleStatusChange = (e, id, statusID) => {
    const selectedStatus = leadStatus.find((label) => label.id === statusID);
    if (!selectedStatus) return;
    const updatedData = filteredData.map((lead) => {
      if (lead.id === id) {
        return { ...lead, status: selectedStatus, statusID: statusID };
      }
      return lead;
    });

    setFilteredData(updatedData);
    patchWithToken(`Lead_ListAPI/${id}`, apiTokenData, {
      status_id: statusID,
    })
      .then((response) => {
        if (response.status === 200) {
          getLeadDetails(apiTokenData, activeStatus);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
        toast.error('Something went wrong');
      });
  };

  const formattedDates = filteredData.map((obj) => {
    const currentDate = new Date();
    const createdAtDate = new Date(obj?.createdAt);

    let formattedDate;

    if (isSameDay(currentDate, createdAtDate)) {
      formattedDate = 'Today';
    } else if (isYesterday(currentDate, createdAtDate)) {
      formattedDate = 'Yesterday';
    } else {
      formattedDate = moment(createdAtDate).format('DD-MM-YYYY');
    }

    function isSameDay(date1, date2) {
      return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
    }

    function isYesterday(date1, date2) {
      const yesterday = new Date(date1);
      yesterday.setDate(date1.getDate() - 1);

      return isSameDay(yesterday, date2);
    }

    return formattedDate;
  });

  const handleDelateLead = (e, id) => {
    e.stopPropagation();
    setLoader(true);
    deleteWithToken(`Lead_ListAPI/${id}`, apiTokenData)
      .then((response) => {
        if (response.status === 200) {
          getLeadDetails(apiTokenData, activeStatus);
          toast.success(response?.message);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getstatus = (token) => {
    setLoader(true);
    getWithToken('lead_status', token)
      .then((response) => {
        if (response.status === 200) {
          setLeadSatus(response?.data);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoader(false); // always executes
      });
  };

  const handleOpenPopup = (label) => {
    setShowPopup(true);
    setEditLabel(label);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setEditLabel(null);
  };

  const handleSaveLabel = async (id, name, color) => {
    try {
      if (id) {
        const response = await patchWithToken(`lead_status/${id}`, apiTokenData, { status_name: name, status_color: color });
        if (response.status === 200) {
          toast.success(response.message);
          getstatus(apiTokenData);
          getLeadDetails(apiTokenData, activeStatus);
        } else {
          toast.error(response.message);
        }
      } else {
        const response = await postWithToken('lead_status', apiTokenData, { status_name: name, status_color: color });
        if (response.status === 201) {
          toast.success(response.message);
          getstatus(apiTokenData);
        } else {
          toast.error(response.message);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteStatus = async (id) => {
    try {
      const response = await deleteWithToken(`lead_status/${id}`, apiTokenData);
      if (response.status === 200) {
        toast.success(response.message);
        getstatus(apiTokenData);
        getLeadDetails(apiTokenData, activeStatus);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const LabelPopup = ({ onClose, onSave, labelData }) => {
    const [name, setName] = useState(labelData?.status_name || '');
    const [color, setColor] = useState(labelData?.status_color || '#3498db');

    const handleSave = () => {
      onSave(labelData?.id, name, color);
      onClose();
    };

    const handleCancel = () => {
      onClose();
    };

    const handleInputChange = (event) => {
      setName(event.target.value);
    };
    const handleColorChange = (event) => {
      setColor(event.target.value);
    };

    return (
      <>
        <div className='new-label-popup'>
          <div className='popup-content'>
            <input type='text' placeholder='Enter status name' value={name} onChange={handleInputChange} />
            <div className='knowledge-hub chatbox-input-text p-1'>
              <div className='row g-3 align-items-center'>
                <p className='outfit-medium bubbles-text mb-0'>Status Color</p>
                <div className='d-flex align-items-center gap-2 mt-0'>
                  <input type='color' id='userTextColor' name='color' value={color} className='form-control form-control-color rounded-2' onChange={handleColorChange} />
                  <p className='outfit-regular mb-0 form-control-color-text'>{color}</p>
                </div>
              </div>
            </div>
            <div className='button-container'>
              <button className='btn-modal-save' onClick={handleSave}>
                Save
              </button>
              <button className='btn-modal-cancel' onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div className='popup-overlay' onClick={handleCancel} />
      </>
    );
  };

  useEffect(() => {
    if (selectedLead) {
      setEditedLead({ ...selectedLead });
    }
  }, [selectedLead]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedLead((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveDetails = () => {
    const payload = {
      name: editedLead.name,
      email: editedLead.email,
      phone_number: editedLead.phone_number,
      status_id: editedLead?.status?.id ? editedLead?.status?.id : editedLead?.status,
      note: editedLead?.note,
    };

    patchWithToken(`Lead_ListAPI/${selectedLead?.id}`, apiTokenData, payload)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          const leadData = response?.data;

          // 👇 Only keep status ID
          const modifiedLead = {
            ...leadData,
            status: leadData.status?.id,
          };
          setSelectedLead(modifiedLead);
          getLeadDetails(apiTokenData, activeStatus);
          setIsEditing(false);
          setIsEditingQuestion(false);
          toast.success(response?.message);
        } else {
          toast.error('Failed to update lead');
        }
      })
      .catch((error) => {
        console.error('error:', error);
        toast.error('Something went wrong');
      });
  };

  const handleCancel = () => {
    setEditedLead({ ...selectedLead });
    setIsEditing(false);
  };

  return (
    <>
      <div className='m-0 mt-2 ps-md-5 ps-sm-4 ps-4 pe-md-5 pe-sm-4 pe-4 mb-3'>
        <div className='lead-section'>
          <div className='comniq-container'>
            <div className=''>
              <div className='analytics-header d-flex justify-content-between align-items-center'>
                <div>
                  <h6 className='mb-0 outfit-bold text-white d-flex align-items-center'>Generated Leads</h6>
                  <p className='mb-0 outfit-regular'>Manage and track all leads generated through your ComniqAI chatbot.</p>
                </div>
              </div>
            </div>

            <div className='lead-section__topbar d-flex justify-content-between align-items-center  mt-4'>
              <div className='lead-section__search w-25 position-relative'>
                <img src={SEARCH_ICON} alt='search-icon' />
                <input type='text' className='form-control' placeholder='Search leads...' value={search} onChange={(e) => handleSearch(e)} />
              </div>

              <div className='lead-section__actions d-flex gap-2'>
                <div className='d-flex align-items-center flex-wrap gap-2'>
                  <div className='position-relative date-picker-wrapper'>
                    <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} placeholderText='Start date' className='form-control m-0' ref={dateRef} />
                    <img src={CALENDAR_ICON} alt='Calendar icon' className='calendar-icon position-absolute' onClick={() => dateRef.current.setFocus()} />
                  </div>
                  <div className='chatbox-field'>
                    <div className='dropdown select-dropdown' id='custom-select'>
                      <button className='btn-generatedlead outfit-medium' type='button' data-bs-toggle='dropdown' aria-expanded='false'>
                        {leadStatus.map((label) => (
                          <span className='outfit-medium' key={label?.id}>
                            {label.id === filterStatus && label.status_name}
                          </span>
                        ))}
                        <span className='outfit-medium'>{!filterStatus && 'Select/ Add Status'}</span>
                      </button>
                      <ul className='dropdown-menu p-2' id='dropdown-menu'>
                        {leadStatus.map((label) => (
                          <li className='dropdown-item' key={label?.id}>
                            <div className='dropdown-item-list w-100' onClick={() => setFlterStatus(label?.id)}>
                              <button className='btn p-0'>
                                <span className='outfit-regular'>{label.status_name}</span>
                              </button>
                            </div>
                            <div className='dropdown-item-icons'>
                              <button className='btn p-0' onClick={() => handleOpenPopup(label)}>
                                <MdOutlineModeEditOutline />
                              </button>
                              <button className='btn p-0' onClick={() => handleDeleteStatus(label?.id)}>
                                <MdOutlineDeleteForever />
                              </button>
                            </div>
                          </li>
                        ))}
                        <li className='dropdown-item new-label mt-2' onClick={() => handleOpenPopup(null)}>
                          <FaPlus />
                          <span className='outfit-regular ps-2 text-white'>Create a new status</span>
                        </li>
                      </ul>
                      {showPopup && <LabelPopup onClose={handleClosePopup} onSave={handleSaveLabel} labelData={editLabel} leadStatusColor={leadStatus} />}
                    </div>
                  </div>
                  <button
                    className='btn-modal-cancel'
                    onClick={() => {
                      setFlterStatus(null);
                      setStartDate(null);
                    }}
                  >
                    Clear all
                  </button>
                </div>
              </div>
            </div>

            {/* <div className='soft-tab-wrapper d-flex p-1 w-100 mt-4'>
            {statusTabs.map((tab) => (
              <button key={tab} className={`soft-tab-btn gap-2 ${activeStatus === tab.label ? 'active' : ''}`} onClick={() => setActiveStatus(tab.label)}>
                {tab.label} <span className='lead-badge rounded-pill outfit-regular'>{tab?.count}</span>
              </button>
            ))}
          </div> */}

            <div className='custom-table-container mt-4'>
              <div className='table-responsive'>
                <table className='table table-hover table-bordered align-middle mb-0'>
                  <thead className='table-light'>
                    <tr>
                      {/* <th className='text-center'></th> */}
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Date</th>
                      <th className='text-center'>Status</th>
                      <th className='text-center'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData?.length > 0 ? (
                      filteredData?.map((lead, index) => (
                        <tr
                          key={lead?.id}
                          onClick={() => {
                            setSelectedLead(lead);
                            setShowModal(true);
                            handleToggleChatHistory(lead);
                          }}
                        >
                          {/* <td className='text-center'>
                        <div className='form-check custom-round-checkbox'>
                          <input className='form-check-input' type='checkbox' id='selectToggle' checked={true} />
                          <label for={index + 1}></label>
                        </div>
                      </td> */}
                          <td onMouseEnter={(e) => handleMouseEnter(e, lead.lead_summary)} onMouseLeave={handleMouseLeave}>
                            <div className='d-flex align-items-center gap-2'>
                              <div
                                className='rounded-circle d-flex align-items-center justify-content-center'
                                style={{ width: 30, height: 30, background: 'rgba(220, 83, 133, 0.1)', color: '#dc5385' }}
                              >
                                {lead?.name
                                  ?.split(' ')
                                  .map((n) => n[0])
                                  .join('')}
                              </div>
                              {lead?.name}
                            </div>
                          </td>
                          <td onMouseEnter={(e) => handleMouseEnter(e, lead.lead_summary)} onMouseLeave={handleMouseLeave}>
                            {lead?.email}
                          </td>
                          <td onMouseEnter={(e) => handleMouseEnter(e, lead.lead_summary)} onMouseLeave={handleMouseLeave}>
                            {lead?.phone_number}
                          </td>
                          <td>{formattedDates[index]}</td>
                          <td>
                            <div className='select-dropdown d-flex justify-content-center' id='custom-select'>
                              <button
                                className='btn btn-secondary custom-dropdown-toggle dropdown-toggle d-flex align-items-center justify-content-center gap-1'
                                type='button'
                                data-bs-toggle='dropdown'
                                aria-expanded='false'
                                style={{
                                  width: '100px',
                                  height: '25px',
                                  borderRadius: '34px',
                                  background: lead?.status?.status_color || 'linear-gradient(135deg, #b94feb, #f4543a)',
                                  color: getTextColor(lead?.status?.status_color),
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {lead?.status?.status_name || 'Select'}
                              </button>

                              <ul className='dropdown-menu p-1 mt-2' id='dropdown-menu' style={{ width: '120px', minWidth: '120px' }}>
                                {leadStatus && leadStatus.length > 0 ? (
                                  leadStatus?.map((label, index) => (
                                    <li className='dropdown-item p-0 mb-1' key={index}>
                                      <div className='dropdown-item-list w-100'>
                                        <button
                                          className='btn text-start w-100'
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleStatusChange(e, lead?.id, label.id);
                                          }}
                                        >
                                          <span className='outfit-regular'>{label.status_name}</span>
                                        </button>
                                      </div>
                                    </li>
                                  ))
                                ) : (
                                  <li className='dropdown-item p-0 mb-1'>
                                    <div className='dropdown-item-list w-100'>
                                      <button className='btn text-start w-100' disabled>
                                        No Status
                                      </button>
                                    </div>
                                  </li>
                                )}
                              </ul>
                            </div>
                            {/* <span
                            className={`${lead.status && 'lead-badge'} rounded-pill outfit-regular`}
                            style={{
                              background:
                                lead?.status?.status_name === 'New'
                                  ? '#dbeafe'
                                  : lead?.status?.status_name === 'Qualified'
                                  ? '#dcfce7'
                                  : lead?.status?.status_name === 'Archived'
                                  ? '#f3e8ff'
                                  : '#fef3c7',
                              color:
                                lead?.status?.status_name === 'New'
                                  ? '#1e40af'
                                  : lead?.status?.status_name === 'Qualified'
                                  ? '#166534'
                                  : lead?.status?.status_name === 'Archived'
                                  ? '#6b21a8'
                                  : '#92400e',
                            }}
                          >
                            {lead?.status?.status_name || '-'}
                          </span> */}
                          </td>
                          <td className='text-center'>
                            <div className='cursor-pointer' style={{ color: '#727374' }} onClick={(e) => handleDelateLead(e, lead?.id)}>
                              <MdOutlineDeleteForever style={{ width: '25px', height: '25px' }} />
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>
                          <p className='outfit-bold text-center text-dark py-3' style={{ fontSize: '30px' }}>
                            No Records Found
                          </p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {tooltipData.visible && tooltipData.content && (
        <div
          className='custom-table-tooltip'
          style={{
            position: 'fixed',
            top: tooltipData.y + 10,
            left: tooltipData.x + 10,
          }}
        >
          {tooltipData.content}
        </div>
      )}
      {showModal && (
        <CustomModal
          show={showModal}
          onHide={() => setShowModal(false)}
          maxWidth='56rem'
          maxHeight='90vh'
          title={
            <div className='lead-title-section'>
              <div className='title-coloum'>
                <h5 className='title-text outfit-semibold'>{selectedLead.name}</h5>
                <div className='d-flex align-items-center gap-2'>
                  <small className='badge rounded-pill'>New Lead</small>
                  <span className='outfit-regular'> {formatTimestamp(selectedLead?.createdAt)}</span>
                </div>
              </div>
              <button
                className='btn-close'
                onClick={() => {
                  setShowModal(false);
                  setActiveTab('details');
                  setIsEditing(false);
                }}
              ></button>
            </div>
          }
        >
          {selectedLead && (
            <div className='lead-detail-modal'>
              <div className='custom-tabs'>
                <div className='tab-buttons pt-2'>
                  {tabs.map((tab) => (
                    <button key={tab} className={`tab-btn outfit-medium ${activeTab === tab.toLowerCase() ? 'active' : ''}`} onClick={() => setActiveTab(tab.toLowerCase())}>
                      {tab}
                    </button>
                  ))}
                </div>

                <div className='lead-active-tab'>
                  {activeTab === 'details' && (
                    <div className=''>
                      <div className='d-flex justify-content-between align-items-start mb-4'>
                        <h5 className='outfit-semibold'>Lead Information</h5>
                        {!isEditing ? (
                          <button className='btn-add-faq outfit-medium d-flex align-items-center' onClick={() => setIsEditing(true)}>
                            <FiEdit3 className='me-2' />
                            Edit
                          </button>
                        ) : (
                          <div className='d-flex flex-wrap justify-content-end gap-2 action-btn-group'>
                            <button className='btn-modal-cancel outfit-medium' onClick={handleCancel}>
                              ✖ Cancel
                            </button>
                            <button className='btn-modal-save outfit-medium' onClick={handleSaveDetails}>
                              ✔ Save
                            </button>
                          </div>
                        )}
                      </div>

                      <div className='row gy-4'>
                        <div className='col-md-6'>
                          <label className='form-label label-text outfit-medium'>Name</label>
                          {!isEditing ? (
                            <div className='info-box d-flex align-items-center outfit-regular'>
                              <MdOutlineMail className='me-2' />
                              {selectedLead?.name}
                            </div>
                          ) : (
                            <input type='text' className='form-control outfit-regular' name='name' value={editedLead?.name} onChange={handleChange} />
                          )}
                        </div>
                        <div className='col-md-6'>
                          <label className='form-label label-text outfit-medium'>Email</label>
                          {!isEditing ? (
                            <div className='info-box d-flex align-items-center outfit-regular'>
                              <MdOutlineMail className='me-2' />
                              {selectedLead?.email}
                            </div>
                          ) : (
                            <input type='text' className='form-control outfit-regular' name='email' value={editedLead?.email} onChange={handleChange} />
                          )}
                        </div>

                        <div className='col-md-6'>
                          <label className='form-label label-text outfit-medium'>Phone</label>
                          {!isEditing ? (
                            <div className='info-box d-flex align-items-center outfit-regular'>
                              <FiPhone className='me-2' />
                              {selectedLead?.phone_number}
                            </div>
                          ) : (
                            <input type='text' className='form-control outfit-regular' name='phone_number' value={editedLead?.phone_number} onChange={handleChange} />
                          )}
                        </div>
                        {isEditing && (
                          <div className='col-md-6'>
                            <label className='form-label label-text outfit-medium'>Lead Status</label>
                            <select
                              className='form-control box-shadow-hover'
                              name='status'
                              value={editedLead?.status?.id ? editedLead?.status?.id : editedLead?.status}
                              onChange={handleChange}
                            >
                              <option value='' disabled hidden>
                                Choose the status
                              </option>
                              {leadStatus?.map((row) => (
                                <option key={row?.id} value={row?.id}>
                                  {row.status_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        {!isEditing && (
                          <div className='col-md-6'>
                            <label className='form-label label-text outfit-medium'>Date Added</label>
                            <div className='info-box d-flex align-items-center'>
                              <FiCalendar className='me-2' />
                              {formatTimestamp(selectedLead?.createdAt)}
                            </div>
                          </div>
                        )}
                      </div>

                      {!isEditing && (
                        <div className='note-card mt-4'>
                          <div className='d-flex justify-content-between align-items-center mb-2'>
                            <div>
                              <h6 className='outfit-semibold mb-0'>{selectedLead?.name}</h6>
                              <span className='small'>Sales Representative</span>
                            </div>
                            <div className='badge rounded-pill d-flex align-items-center gap-2 outfit-regular'>
                              <FaRegClock />
                              {formatTimestamp(selectedLead?.createdAt)}
                            </div>
                          </div>

                          <p className='mb-0 outfit-regular'>{selectedLead?.lead_summary}</p>
                        </div>
                      )}
                    </div>
                  )}
                  {activeTab === 'chat' && (
                    <div className='chat-history-section'>
                      <div className='chat-history-header d-flex justify-content-between align-items-center mb-3'>
                        <h5 className='outfit-medium mb-0'>Chat History</h5>
                      </div>

                      <div className='knowledge-hub' style={{ height: '300px', overflow: 'auto' }}>
                        {getLeadData?.map((obj, index) => (
                          <div className='mb-4' key={obj.id || index}>
                            {/* User Message */}
                            <div className='d-flex align-items-center justify-content-end mt-3'>
                              <div className='chat-history-message user'>
                                <p className='m-0' style={{ whiteSpace: 'pre-line' }}>
                                  {formatText(obj?.prmt)}
                                </p>
                              </div>
                            </div>

                            {/* Agent Message */}
                            {obj?.text?.length > 0 && (
                              <div
                                className='d-flex align-items-start editdata-chatbox mt-3 position-relative'
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                              >
                                <div className='chat-history-message agent'>
                                  <p className='m-0'>
                                    <Linkify
                                      componentDecorator={(decoratedHref, decoratedText, key) => (
                                        <a key={key} href={decoratedHref} target='_blank' rel='noreferrer'>
                                          {decoratedText}
                                        </a>
                                      )}
                                    >
                                      {obj.text}
                                    </Linkify>
                                  </p>

                                  {/* Feedback Icons */}
                                  <div className={`message-actions bot-actions d-flex gap-2 mt-2 ${hoveredIndex === index ? 'show' : ''}`}>
                                    <button
                                      className='action-btn'
                                      title='Positive feedback'
                                      style={{
                                        color: obj.is_positive_rating ? '#000000' : '#9CA3AF',
                                      }}
                                    >
                                      <ThumbsUp size={16} fill={obj.is_positive_rating ? '#000000' : 'none'} />
                                    </button>

                                    <button
                                      className='action-btn'
                                      title='Negative feedback'
                                      style={{
                                        color: obj.is_negative_rating ? '#000000' : '#9CA3AF',
                                      }}
                                    >
                                      <ThumbsDown size={16} fill={obj.is_negative_rating ? '#000000' : 'none'} />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {activeTab === 'notes' && (
                    <div className='note-card-section position-relative rounded'>
                      <div className='d-flex justify-content-between align-items-center mb-3'>
                        <h5 className='outfit-medium mb-0'>Notes</h5>
                      </div>
                      <div className='mb-4'>
                        {isEditingQuestion ? (
                          <>
                            <div className='mb-3'>
                              <div className='chatbox-input-text input-GPT new'>
                                <div className='chatbox-input-field'>
                                  <textarea
                                    rows='10'
                                    className='form-control chatbox-input faq-textarea-height box-shadow-hover outfit-regular'
                                    placeholder='Enter lead notes'
                                    name='note'
                                    value={editedLead?.note}
                                    onChange={handleChange}
                                    maxLength={1500}
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                            <div className='d-flex flex-wrap justify-content-end gap-2 action-btn-group'>
                              <button className='btn-modal-cancel outfit-medium' onClick={() => setIsEditingQuestion(false)}>
                                ✖ Cancel
                              </button>
                              <button className='btn-modal-save outfit-medium' onClick={handleSaveDetails}>
                                ✔ Save
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className='notes_preview outfit-regular' onClick={() => setIsEditingQuestion(true)}>
                            <i>{editedLead?.note?.trim() ? editedLead.note : 'Click here to add a note...'}</i>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {activeTab === 'activities' && (
                    <div className='knowledge-hub shadow-sm text-center p-3'>
                      <p className='outfit-medium mb-0'>Comming Soon...</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </CustomModal>
      )}

      {loader && (
        <div className='loader-center'>
          <Loader />
        </div>
      )}
    </>
  );
};

export default MyLeads;
